export default __webpack_public_path__ + "static/media/Artboard – 1.a4c69ecb.png";